import { render } from "./CoverList.vue?vue&type=template&id=2f2d9228&scoped=true"
import script from "./CoverList.vue?vue&type=script&lang=js"
export * from "./CoverList.vue?vue&type=script&lang=js"

import "./CoverList.vue?vue&type=style&index=0&id=2f2d9228&scoped=true&lang=css"

import exportComponent from "/root/workspace/Collection_EVMd/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f2d9228"]])

export default __exports__